import { render } from "./JroProjectNew.vue?vue&type=template&id=1353eb23&scoped=true&ts=true"
import script from "./JroProjectNew.vue?vue&type=script&lang=ts"
export * from "./JroProjectNew.vue?vue&type=script&lang=ts"

import "./JroProjectNew.vue?vue&type=style&index=0&id=1353eb23&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_typescript@5.1.6__webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1353eb23"]])

export default __exports__